import React from 'react';
import { Box, Text } from '@chakra-ui/react';
import { QRCodeSVG } from 'qrcode.react';

const QRCodeBox = ({ url }) => {
  const qrUrl = url || window.location.origin + '/mobile/checkin';
  console.log('[QRCodeBox] Gerando QR Code para:', qrUrl);

  return (
    <Box
      width="280px"
      height="320px"
      bg="white"
      borderRadius="md"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      p={4}
    >
      <QRCodeSVG 
        value={qrUrl}
        size={200}
        level="H"
        includeMargin={true}
        style={{ width: '200px', height: '200px' }}
      />
      <Text mt={4} color="black" fontWeight="bold" fontSize="lg">
        Escaneie o QR Code
      </Text>
    </Box>
  );
};

export default QRCodeBox;
